import {ClientFilterRequestType, ClientFilterType, ClientRequestType, ClientType} from "@client/types/client.types";

export const mapClientToRequestType = (client: ClientType): ClientRequestType => {
    return {
        firstName: client.firstName ?? '',
        lastName: client.lastName ?? '',
        companyName: client.companyName ?? '',
        status: client.status?.id ?? '',
        nip: client.nip ?? '',
        phone: client.phone ?? '',
        email: client.email ?? '',
        address: {
            street: client.address.street ?? '',
            postCode: client.address.postCode ?? '',
            city: client.address.city ?? '',
            buildingNumber: client.address.buildingNumber ?? '',
            localNumber: client.address.localNumber ?? '',
        }
    };
}

export const mapClientFilterRequestToClientFilterType =
    (clientFilterRequestType: ClientFilterRequestType)
        : ClientFilterType => {
        return {
            search: clientFilterRequestType?.search ?? '',
            page: clientFilterRequestType.page ?? 1,
        }
    }

